module.exports = __webpack_public_path__ + "img/diagram-360_mobile.17ca3aa9.jpg";